/* eslint-disable react/prop-types */
import React from 'react';
import { BarWave } from 'react-cssfx-loading';
import { useParams } from 'react-router-dom';
// eslint-disable-next-line import/no-extraneous-dependencies
import Proptypes from 'prop-types';
// import { useGetArticleQuery } from '../../redux/public/publicSlice';
import { useGetArticleQuery } from '../../redux/apiSlice';
import ReadMore from './ReadMore';

function Article() {
  const { id } = useParams();
  const {
    data: article,
    isLoading: articleLoadingStatus,
    isSuccess: articleSuccessStatus,
    isError: articleErrorStatus,
  } = useGetArticleQuery(+id);

  let content;
  if (articleLoadingStatus) {
    content = (
      <div
        className="bg-gray-900 bg-opacity-90 lg:p-16 p-8 fixed z-50 w-full h-full top-0 left-0 flex flex-col items-center justify-center"
      >
        <BarWave color="#54c5fc" height="2rem" width="8rem" />
      </div>
    );
  } else if (articleErrorStatus) {
    content = <div className="text-red-500">An error occurred while fetching this article</div>;
  } else if (articleSuccessStatus) {
    content = (
      <div className="flex flex-col gap-2 xl:mx-24 lg:mx-12 mx-6 lg:p-16 md:p-8 p-4">
        <div className="flex flex-col gap-1 lg:py-6 py-3">
          <div className="px-2 flex flex-col lg:mb-6 mb-3">
            <h3 className="xl:text-xl lg:text-lg text-sm text-blue-500">{`By ${article[0].name}`}</h3>
            <p className="text-gray-600 xl:text-lg lg:text-md text-xs">
              {`Posted on ${new Date(article[0].post_date).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              })}`}
            </p>
          </div>
          <h2 className="font-bold xl:text-2xl lg:text-xl text-md text-gray-700 xl:mb-12 md:mb-6 mb-3 xl:px-24 md:px-12 px-6">
            {article[0].post_title}
          </h2>
          <p className="xl:text-lg lg:text-md text-sm text-gray-700 my-1 md:mb-8 mb-4 xl:px-24 lg:px-12 md:px-6 list-disc">
            {/* Using the ReadMore component */}
            <ReadMore content={article[0].post_content} maxLength={500} />
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full xl:mt-24 mt-16">
      {content}
    </div>
  );
}

Proptypes.propTypes = {
  article: Proptypes.isRequired,
};

export default Article;
